import React from 'react'
import THEME from 'utils/theme'

export default function MailIcon({ color = THEME.COLORS.TEXTCOLOR, width = '18px', height = '18px' }) {
  return (
    <svg viewBox='0 0 23 19' className='svgIcon iconMail' style={{ width, height }}>
      <title>Mail</title>
      <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g transform='translate(3.000000, 2.000000)' className='stroke' stroke={color} strokeWidth='1.9'>
          <rect x='0' y='0.8' width='17.1' height='13.3'></rect>
          <polyline points='0 1.75 8.95250318 8.4 17.1 1.75'></polyline>
        </g>
      </g>
    </svg>
  )
}
